import type {WellbeingEntryKey} from '@kroll-resolver-crisp/ui-components-react';

// Where the shell's Wellbeing dialog points. The design system ships the copy and refuses to
// default the destinations, so they are committed here instead: Resolver-wide pages, not
// per-environment ones, so every deployment gets the same links without setting anything. Each
// can still be overridden per deployment with its VITE_WELLBEING_* build arg (an unset ARG reaches
// Vite as an empty string, which the `||` below treats as absent). An entry with no URL renders
// disabled rather than dead.

// People Hub > Wellbeing - the People Team's wellbeing landing page: mental health guidance, the
// apps and benefits, and the People Team contact. It is also the only place the EAP is indexed for
// every office: its first panel, "Quick Links to our Employee Assistance Programme", links each
// country's provider (Health Assured in the UK, Unum in the US, the Kroll/LifeWorks programme in
// Manila, Kroll's own pages for Mexico and India). There is no single provider URL to link instead,
// so the EAP entry lands on that panel too.
const PEOPLE_HUB_WELLBEING =
  'https://crispthinking1.atlassian.net/wiki/spaces/PH/pages/2177105954/Wellbeing';

// Redlines has no default: analyst redlines are a per-user preference in Apollo (GT-13284), and
// neither a Confluence page nor a stable Apollo URL for setting them exists yet.
const DEFAULTS: Readonly<Partial<Record<WellbeingEntryKey, string>>> = {
  assistance: PEOPLE_HUB_WELLBEING,
  confluence: PEOPLE_HUB_WELLBEING
};

const KEYS: readonly WellbeingEntryKey[] = ['assistance', 'redlines', 'confluence'];

export function wellbeingHrefs(
  overrides: Readonly<Partial<Record<WellbeingEntryKey, string | undefined>>>
): Readonly<Partial<Record<WellbeingEntryKey, string>>> {
  const hrefs: Partial<Record<WellbeingEntryKey, string>> = {};

  for (const key of KEYS) {
    const href = overrides[key] || DEFAULTS[key];
    if (href) {
      hrefs[key] = href;
    }
  }

  return hrefs;
}

export const WELLBEING_HREFS = wellbeingHrefs({
  assistance: import.meta.env.VITE_WELLBEING_EAP_URL,
  redlines: import.meta.env.VITE_WELLBEING_REDLINES_URL,
  confluence: import.meta.env.VITE_WELLBEING_CONFLUENCE_URL
});
